export const validaNis = (numeroNis: string, formulario: any): boolean => {
    var ftap: string = '3298765432';
    var total: number = 0;
    var resto: number = 0;
    var strResto: string = '';
    var numPIS: string = numeroNis;

    if (!numPIS) {
        formulario.nis.$error = {};
        return true;
    }

    for (var i = 0; i <= 9; i++) {
        var resultado: number = parseInt(numPIS.slice(i, i + 1), 10) * parseInt(ftap.slice(i, i + 1), 10);
        total = total + resultado;
    }

    resto = (total % 11);

    if (resto !== 0) {
        resto = 11 - resto;
    }

    if (resto === 10 || resto === 11) {
        strResto = resto + '';
        resto = parseInt(strResto.slice(1, 2), 10);
    }

    if (resto !== parseInt(numPIS.slice(10, 11), 10)) {
        formulario.nis.$error = { 'nisInvalido': true };
        return false;
    } else {
        formulario.nis.$error = { 'nisInvalido': false };
        return true;
    }

};
